import { render } from "./Trazabilidad.vue?vue&type=template&id=43acfeb5&scoped=true"
import script from "./Trazabilidad.vue?vue&type=script&lang=js"
export * from "./Trazabilidad.vue?vue&type=script&lang=js"

import "./Trazabilidad.vue?vue&type=style&index=0&id=43acfeb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43acfeb5"]])

export default __exports__